import React, { useState, useEffect } from 'react';
import { formatCurrency } from '../gameData';
import { getTopScores, LEADERBOARD_SIZE } from '../leaderboard';

function LeaderboardDialog({ show, onClose }) {
  const [scores, setScores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!show) return;
    let active = true;
    setLoading(true);
    getTopScores().then(top => {
      if (!active) return;
      setScores(top);
      setLoading(false);
    });
    return () => { active = false; };
  }, [show]);

  if (!show) return null;

  return (
    <dialog open={show} className="gameover-dialog">
      <h2>🏅 Top {LEADERBOARD_SIZE} Kingpins</h2>

      {loading ? (
        <p>Loading leaderboard…</p>
      ) : scores.length === 0 ? (
        <p>No scores yet — survive to day 30 and claim the top spot!</p>
      ) : (
        <table className="leaderboard-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Initials</th>
              <th>Net Worth</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {scores.map((s, i) => (
              <tr key={s.ts ?? i}>
                <td>{i + 1}</td>
                <td>{s.initials}</td>
                <td>{formatCurrency(s.netWorth)}</td>
                <td>{s.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <div className="dialog-buttons">
        <button className="primary-button" onClick={onClose}>Close</button>
      </div>
    </dialog>
  );
}

export default LeaderboardDialog;
